<section>
  <div class="row">
    <div class="col-6">
      <div class="row text-center">
        <div class="col-4">
          <app-progress-circle [percentage]="completionPercentage"></app-progress-circle>
          <h6 class="mt-2">Subject Progress</h6>
        </div>

        <div class="col-4">
          <app-progress-circle [percentage]="lastExerciseAccuracy"></app-progress-circle>
          <h6 class="mt-2">Last Exercise Accuracy</h6>
        </div>

        <div class="col-4">
          <app-progress-circle [percentage]="lifetimeAccuracy"></app-progress-circle>
          <h6 class="mt-2">Lifetime Accuracy</h6>
        </div>
      </div>
    </div>

    <div class="col-6 align-self-center">
      <div class="row px-5">
        <div class="col-6">
          @if (video) {
            <button class="btn btn-sm btn-outline-primary btn-block" (click)="open(content)">View Intro</button>
          }
        </div>
        <div class="col-6">
          <a class="btn btn-sm btn-outline-warning btn-block" [routerLink]="['/student/history']">Review Flagged</a>
        </div>
      </div>
    </div>
  </div>
</section>

@if (exercisePerformanceMetrics && lessons && lessons.length) {
  <div ngbAccordion class="subject-levels" [closeOthers]="true">
    @for (lesson of lessons; track lesson) {
      <div [ngbAccordionItem]="'' + lesson.id" [collapsed]="lesson.id !== lessons[0].id">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>
            <span class="lesson-title">{{ lesson.title }}</span>
            <div class="lesson-progress">
              <ngb-progressbar showValue="true" type="success" [value]="getLessonCompletion(lesson.id)"></ngb-progressbar>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <table class="table">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Exercises</th>
                    <th scope="col"></th>
                    <th scope="col">First Score</th>
                    <th scope="col">Last Score</th>
                    <th scope="col">Best Score</th>
                    <th scope="col">Attempts</th>
                    <th scope="col">Complete</th>
                  </tr>
                </thead>
                @for (exercise of lesson.exercises; track exercise) {
                  <tbody>
                    <tr>
                      <th scope="row"><a [routerLink]="['exercise/' + exercise.id + '/intro']">{{ exercise.title }}</a></th>
                      <td></td>
                      @if (exercisePerformanceMetrics.get(exercise.id)) {
                        <td>{{exercisePerformanceMetrics.get(exercise.id).firstScore}}/{{exercisePerformanceMetrics.get(exercise.id).firstScoreAttempted}}</td>
                        <td>{{exercisePerformanceMetrics.get(exercise.id).lastScore}}/{{exercisePerformanceMetrics.get(exercise.id).lastScoreAttempted}}</td>
                        <td>{{exercisePerformanceMetrics.get(exercise.id).bestScore}}/{{exercisePerformanceMetrics.get(exercise.id).bestScoreAttempted}}</td>
                        <td>{{exercisePerformanceMetrics.get(exercise.id).attempts}}</td>
                      } @else {
                        <td>0</td><td>0</td><td>0</td><td>0</td>
                      }
                      <td>@if (completedExerciseIds.includes(exercise.id)) {
                        <i class="fa fa-check-circle"></i>
                      }</td>
                    </tr>
                  </tbody>
                }
              </table>
            </ng-template>
          </div>
        </div>
      </div>
    }
  </div>
}

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Subject Intro Video</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-4">
    <div class="embed-responsive embed-responsive-16by9">
      <video class="embed-responsive-item" allowfullscreen autoplay>
        <source src="https:{{video.file.url}}" type="video/mp4">
      </video>
    </div>
  </div>
</ng-template>
